module.exports = __webpack_public_path__ + "static/media/02.f0980cd0.jpg";